import styled from 'styled-components';

export const SpeakerSummaryListContainer = styled.div`
  overflow: hidden;
`;
